import { render, staticRenderFns } from "./Fix.vue?vue&type=template&id=c8fe0508"
import script from "./Fix.vue?vue&type=script&lang=js"
export * from "./Fix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports